export default{
    state: {
        alert:{
            active: false,
            message: '',
            timeOut: 2000,
            action: ''
        }
    },
    getters: {
        Alert: (state) => state.alert
    },
    mutations: {
        AlertErr: (state, value)=>{
            state.alert.active = !value.success
            state.alert.message = value.message
            state.alert.action = 'error'
        },
    }
}